import {createAction} from "@reduxjs/toolkit";
export const modifyNuclideXYZ = createAction('modify/nuclideXYZ');
export const modifyPeriodicXYZ = createAction('modify/periodicXYZ');
